var React = require('react');

function SquigglyLineDesktop (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n.st0 {\n  fill: none;\n  stroke: #FF8080;\n  stroke-width: 3px;\n  stroke-linecap: round;\n  stroke-miterlimit: 10;\n}\n"),React.createElement("path",{"className":"st0","d":"M106.6,3c0,0,9.6,3.5,17.6,9.2c0,0-9.1,5-13.7,16.4","key":1}),React.createElement("path",{"className":"st0 st0--line","d":"M1.7,19.6c0,0,12.3-8.9,25.1-9.2S48.1,16,51.8,22c3.7,5.9,9.3,21.9-0.3,21.8s-17.1-11.5,5.2-20.6\n\tc5.7-2.3,19.4-4.4,28,3.5S96.8,52.1,84.3,53s-7.5-16.8,5.2-26.6s20.9-13.2,34.3-14.3","key":2})]);
}

SquigglyLineDesktop.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"125.7px","height":"56.5px","viewBox":"0 0 125.7 56.5","xmlSpace":"preserve"};

module.exports = SquigglyLineDesktop;

SquigglyLineDesktop.default = SquigglyLineDesktop;
